import React, { useState, useEffect } from "react";

import { formatName, abbreviateNumber } from "helpers/miscHelpers";

import CountyChart from "./CountyChart";
import { StyledUI, StyledOptionsMenu, StyledGraphHolder } from "./styles";

const CountyGraph = (props) => {
  const { chartType, loadedData, setChartType, numDays = 30 } = props;
  const [dateCount, setDateCount] = useState(numDays);

  function convertToGraphData(data) {
    const dateFields = Object.keys(data.timeline[`${chartType}`]).slice(
      -dateCount
    );

    const output = dateFields.map((df, i) => {
      const pointData = { name: df };
      const countyData = {
        [`${data.name}`]: data.timeline[`${chartType}`][df],
      };

      return Object.assign(pointData, countyData);
    });

    return output;
  }

  return (
    <StyledGraphHolder>
      <CountyChart
        aspectRatio={0.6}
        data={convertToGraphData(loadedData)}
        xField="name"
        yFields={[loadedData.name]}
        scale="linear"
        tooltipFormatter={
          ["casesPer100k", "deathsPer100k"].includes(chartType)
            ? (y) => Number(y).toFixed(3)
            : (d) => abbreviateNumber(d, 2)
        }
        yAxisLabel={
          chartType === "confirmed"
            ? "Confirmed Cases"
            : chartType === "newCases"
            ? "New Cases"
            : chartType === "newDeaths"
            ? "New Deaths"
            : chartType === "deathsPer100k"
            ? "Deaths Per 100k"
            : chartType
        }
        yTickFormatter={
          ["casesPer100k", "deathsPer100k"].includes(chartType)
            ? (y) => Number(y).toFixed(3)
            : (d) => abbreviateNumber(d, 2)
        }
      />

      <StyledOptionsMenu>
        <h3 className="control-title">County Graph Controls</h3>

        <div className="main-options">
          <div className="opt">
            <label htmlFor="c_data">
              Data Type:
              <select
                onChange={(e) => setChartType(e.target.value)}
                className="custom-select"
                // style={{ maxWidth: "180px" }}
                defaultValue={chartType}
                id="c_data"
              >
                <option value="confirmed">Confirmed Cases</option>
                <option value="deaths">Deaths</option>
                <option value="newCases">New Cases</option>
                <option value="newDeaths">New Deaths</option>
                {/* <option value="casesPer100k">Cases per 100k Pop.</option>
                <option value="deathsPer100k">Deaths per 100k Pop.</option> */}
              </select>
            </label>
          </div>

          <div className="opt">
            <label htmlFor="c_days">
              Day Count:
              <select
                onChange={(e) => setDateCount(e.target.value)}
                className="custom-select"
                defaultValue={dateCount}
                id="c_days"
              >
                {[150, 100, 50, 40, 30, 20, 10, 5].map((o) => (
                  <option key={o} value={o}>
                    {o}
                  </option>
                ))}
              </select>
            </label>
          </div>
        </div>
      </StyledOptionsMenu>
    </StyledGraphHolder>
  );
};

export default CountyGraph;
